import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UtilsDataService from "../../services/UtilsDataService";

export const getSettings = createAsyncThunk("utils/getSettings", async () => {
  try {
    const response = await UtilsDataService.getSettings();
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

export const patchSettings = createAsyncThunk("utils/patchSettings", async (data) => {
  try {
    const response = await UtilsDataService.patchSettings(data);
    return { data: response.data, status: response.status, statusText: response.statusText };
  } catch (err) {
    return err.response.data;
  }
});

const UtilsSlice = createSlice({
  name: "utils",
  initialState: {
    appSettings: null,
    loading_getSettings: true,
    loading_patchSettings: false,
  },
  reducers: {},
  extraReducers: {
    [getSettings.pending]: (state) => {
      state.loading_getSettings = true;
    },
    [getSettings.fulfilled]: (state, { payload }) => {
      state.loading_getSettings = false;
      state.appSettings = payload;
    },
    [getSettings.rejected]: (state) => {
      state.loading_getSettings = false;
    },
    [patchSettings.pending]: (state) => {
      state.loading_patchSettings = true;
    },
    [patchSettings.fulfilled]: (state, { payload }) => {
      state.loading_patchSettings = false;
      if (payload?.data) {
        state.appSettings = { ...state.appSettings, data: payload.data };
      }
    },
    [patchSettings.rejected]: (state) => {
      state.loading_patchSettings = false;
    },
  },
});

export default UtilsSlice.reducer;
